import components from '../../common/_components';
import { _on } from '../../common/_events';
import { _getData } from '../../common/_core';
import { _createEl } from '../../common/_create-el';
import { scroll as scrollPage } from '../../common/_scroll-page';

import './scroll-up-button.scss';

const blockName = 'scroll-up-button';
const isShownMod = `${blockName}_is-shown`;

class ScrollUpButton {
    constructor(rootEl) {
        this._rootEl = rootEl;
        this._label = _getData(rootEl, 'buttonLabel');

        this._isCreated = false;
        this._isVisible = false;

        _on(window, 'scroll', this._handleScroll);
        this._handleScroll();
    }

    _handleScroll = () => {
        const isVisible = this._isVisible;

        if (window.pageYOffset > window.innerHeight * 3) {
            if (!isVisible) {
                this._show();
            }
        } else if (isVisible) {
            this._hide();
        }
    };

    _show = () => {
        if (!this._isCreated) {
            this._createButton();
            this._isCreated = true;
        }

        this._rootEl.classList.add(isShownMod);
        this._isVisible = true;
    };

    _hide = () => {
        this._rootEl.classList.remove(isShownMod);
        this._isVisible = false;
    };

    _createButton = () => {
        const buttonEl = _createEl('button', `btn ${blockName}__button`, {
            'aria-label': this._label,
        });

        _on(buttonEl, 'click', this._scrollToTop);
        this._rootEl.appendChild(buttonEl);
    };

    _scrollToTop = () => {
        scrollPage(0, {
            jump: 100,
        });

        return false;
    };
}

components.add(`js-${blockName}`, el => new ScrollUpButton(el));
